import moment from "moment";
import React from "react";
import { ContextMenu, MenuItem } from "react-contextmenu";
import FontAwesome from "react-fontawesome";
import BidActionButtons from "../shared/Event/BidEvent/ActionButtons";
import DeliveryActionButtons from "../shared/Event/DeliveryEvent/ActionButtons";
import JobActionButtons from "../shared/Event/JobEvent/ActionButtons";
import CrewTag from "./CrewTag";
import Day from "./Day";
import styles from "./WeekView.less";
import { isNumber } from "lodash";
import TotalsColumn from "../shared/TotalsColumn";
import { Button, ButtonGroup } from "react-bootstrap";

const WeekView = ({
  className = "",
  date,
  eventsByCrew,
  onCrewSelect,
  onDeleteEventClick,
  onEditDeliveryClick,
  onEditEventClick,
  onPrintWorkOrder,
  onNavigate,
  onOpenClick,
  onReschedule,
  onScheduleBid,
  onScheduleDelivery,
  onScheduleJob,
  onContextMenuClick,
  showTotalsRow,
  showUOMTotals,
  showJobCounts,
  includedItemTypes,
  showEstimatedQuantities,
  showMenuItem,
  settings,
  mode,
  pinTotalsRow,
  onTogglePinTotalsRow,
}) => {
  const startOfWeek = moment(date).startOf("week");
  const endOfWeek = moment(date).endOf("week");

  const dates = [];
  while (startOfWeek.isBefore(endOfWeek)) {
    dates.push(startOfWeek.clone());
    startOfWeek.add(1, "day");
  }

  const weekDayColumns = dates.map((d) => (
    <div
      className={[
        styles.column,
        styles.header,
        moment(date).startOf("day").isSame(d) ? styles.active : "",
      ].join(" ")}
      key={d.format()}
      onClick={() => {
        onNavigate(
          d.format(),
          moment(date).startOf("day").isSame(d) ? "day" : "week"
        );
      }}
    >
      {d.format("dddd")}
      <br />
      {d.format("MMM Do")}
      <br />
    </div>
  ));

  const totalsRowColumns = dates.map((d) => (
    <TotalsColumn
      key={d.format()}
      date={d}
      events={eventsByCrew}
      showJobCounts={showJobCounts}
      showUOMTotals={showUOMTotals}
      includedItemTypes={includedItemTypes}
      showEstimatedQuantities={showEstimatedQuantities}
      currentDate={date}
      styles={styles}
    />
  ));

  const rows = eventsByCrew.map(({ active, crew, events }, i) => (
    <div className={styles.container} key={i}>
      <div className={styles.column}>
        <CrewTag
          active={active}
          crew={crew}
          onCrewSelect={() => onCrewSelect(crew)}
        />
      </div>
      {dates.map((d) => (
        <Day
          active={active && moment(date).startOf("day").isSame(d)}
          crew={crew}
          date={d}
          settings={settings}
          events={events.filter(
            (e) => !d.isBefore(e.startDate) && !d.isAfter(e.endDate)
          )}
          mode={mode}
          key={d.format()}
          onReschedule={onReschedule}
          onScheduleBid={onScheduleBid}
          onScheduleDelivery={onScheduleDelivery}
          onScheduleJob={onScheduleJob}
        />
      ))}
    </div>
  ));

  const headerSection = (pinTotalsRow) => (
    <>
      {showTotalsRow && settings.entity == "jobs" && (
        <div
          className={`${styles.container} ${
            !pinTotalsRow ? styles.header : ""
          }`}
        >
          <div className={styles.column}>
            {settings.entity == "jobs" && (
              <Button
                className={styles.stickyToggle}
                onClick={onTogglePinTotalsRow}
                title={pinTotalsRow ? "Pin Totals Row" : "Unpin Totals Row"}
                active={!pinTotalsRow}
              >
                {pinTotalsRow ? (
                  <>
                    <FontAwesome name="thumb-tack" />
                  </>
                ) : (
                  <>
                    <FontAwesome name="thumb-tack" />
                  </>
                )}
              </Button>
            )}
          </div>
          {totalsRowColumns}
        </div>
      )}
    </>
  );

  return (
    <div className={`${styles.root} ${className}`}>
      <div className={`${styles.container} ${styles.header}`}>
        <div className={styles.column} />
        {weekDayColumns}
      </div>
      {!pinTotalsRow && headerSection(pinTotalsRow)}
      <div className={styles.rows}>
        {pinTotalsRow && headerSection(pinTotalsRow)}
        {rows}
      </div>
      <DeliveryActionButtons
        buttonComponent={MenuItem}
        containerComponent={ContextMenu}
        containerId={"DELIVERY_MENU"}
        onDeleteEventClick={
          onDeleteEventClick
            ? (e, data) => onDeleteEventClick(data.eventId)
            : null
        }
        onEditEventClick={
          onEditDeliveryClick
            ? (e, data) => onEditDeliveryClick(data.eventId)
            : null
        }
        onOpenClick={
          onOpenClick ? (e, data) => onOpenClick(data.eventId) : null
        }
        showLabels
      />
      <JobActionButtons
        buttonComponent={MenuItem}
        containerComponent={ContextMenu}
        containerId={"JOB_MENU"}
        onDeleteEventClick={
          onDeleteEventClick
            ? (e, data) => {
                isNumber(data.eventId)
                  ? onDeleteEventClick(data.eventId)
                  : null;
              }
            : null
        }
        onEditEventClick={
          onEditEventClick
            ? (e, data) => {
                isNumber(data.eventId) ? onEditEventClick(data.eventId) : null;
              }
            : null
        }
        onPrintWorkOrder={
          onPrintWorkOrder
            ? (e, data) => {
                isNumber(data.eventId)
                  ? onPrintWorkOrder({
                      eventId: data.eventId,
                      date: data.date.format("YYYY-MM-DD"),
                    })
                  : null;
              }
            : null
        }
        onOpenClick={
          onOpenClick ? (e, data) => onOpenClick(data.eventId) : null
        }
        showLabels
        showMenuItem={showMenuItem}
        onContextMenuClick={(e) => {
          onContextMenuClick(e.detail.data.eventId);
        }}
      />
      <BidActionButtons
        buttonComponent={MenuItem}
        containerComponent={ContextMenu}
        containerId={"BID_MENU"}
        onOpenClick={
          onOpenClick ? (e, data) => onOpenClick(data.eventId) : null
        }
        showLabels
      />
    </div>
  );
};

export default WeekView;
